import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { getSearchTracfoneSubs, getPageCount } from 'reducers';
import { searchSubs } from 'actions/tracfoneSubs';
import SearchTracfoneSubsComponent from './TracfoneSearchSubs';
import { generateTracfoneRenewalPurchases } from '../../actions/purchases';

const mapStateToProps = (
  state,
  {
    match: {
      params: { page = 1 },
    },
  },
) => ({
  subs: getSearchTracfoneSubs(state, page),
  pageCount: getPageCount(state, 'tracfoneSubs', `search`, page),
  page,
  subscriptionRoute: (subId) => `/tracfone/subscriptions/${subId}/view`,
  pageRoute: (pageNum) => `/tracfone/subsriptions/search/page/${pageNum}`,
});

const mapDispatchToProps = {
  searchSubs,
  generateTracfoneRenewalPurchases,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SearchTracfoneSubsComponent),
);
